import { Icons } from "@/icons/icons"
import { i18n } from "@/plugins/vue-i18n"
import { FirmaRequestStatus } from "@/store/modules/firma/firmaTypes"

export const getStatusTemplate = (): string => {
  const statusTemplate = `
      \${if(isFile)}
        <div class="firma-column">
          \${if(firmaStatus===${FirmaRequestStatus.SENT_TO_FIRMA})}
            <span class=\"firma-status-pending\">${i18n.t('components.firma_status.send_to_firma')}</span>
          \${else}
            \${if(firmaStatus===${FirmaRequestStatus.PENDING_SIGNATURE})}
              <span class=\"firma-status-pending\">${i18n.t('components.firma_status.pending_signature')}</span>
            \${else}
              \${if(firmaStatus===${FirmaRequestStatus.SIGNED})}
                <span class=\"firma-status-signed\">${i18n.t('components.firma_status.signed')}</span>
              \${else}
                \${if(firmaStatus===${FirmaRequestStatus.SIGNED_WITH_AUDIT})}
                  <span class=\"firma-status-signed\">${i18n.t('components.firma_status.signed_with_audit')}</span>
                \${else}
                  \${if(firmaStatus===${FirmaRequestStatus.CANCEL})}
                    <span class=\"firma-status-cancel\">${i18n.t('components.firma_status.cancel')}</span>
                  \${else}
                    \${if(firmaStatus===${FirmaRequestStatus.DOCUMENT_CERTIFIED})}
                      <span class=\"firma-status-certified\">${i18n.t('components.firma_status.certified')}</span>
                    \${else}
                      <span></span>
                    \${/if}
                  \${/if}
                \${/if}
              \${/if}
            \${/if}
          \${/if}
          \${if(firmaMailOrSms)}
            <span class="firma-certified lf-icon-certificate"></span>
          \${else}
          \${/if}
        </div>
      \${else}
      \${/if}`
  return statusTemplate
}

const publicStatusText = {
  ok: i18n.t('components.file_manager.grid_columns.public_ok'),
  ko: i18n.t('components.file_manager.grid_columns.public_ko')
}

export const getPublicTemplate = (): string => {
  const publishTemplate = `
    \${if(public)}
      <div class="public-item">${publicStatusText.ok}</div>
    \${else}
      <div class="not-public-item">${publicStatusText.ko}</div>
    \${/if}`
  return publishTemplate
}

export const getDocsIATemplate = (): string => {
  const docsIATemplate = `
    \${if(type === '.doc' || type === '.docx' || type === '.pdf' || type === '.rtf')}
       <span class="${Icons.IA} docs-ia-icon" data-attr="\${id}" />
    \${/if}`
  return docsIATemplate
}
